import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { use2FAAuth } from '@/hooks/use2FAAuth';
import { Shield } from 'lucide-react';

interface AdminProtectedRouteProps {
  children: JSX.Element;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAdmin, isLoading: isLoadingAdmin } = useAdminAuth();
  const { is2FAEnabled, is2FAVerified, needsSetup, isLoading: isLoading2FA } = use2FAAuth();

  if (isLoadingAdmin || isLoading2FA) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4 flex items-center justify-center">
        <div className="text-center">
          <Shield className="h-8 w-8 text-blue-600 mx-auto mb-4 animate-spin" />
          <p className="text-gray-600">Verificando permissões...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (needsSetup || !is2FAEnabled) {
    return <Navigate to="/admin-2fa-setup" replace />;
  }

  if (!is2FAVerified) {
    return <Navigate to="/admin-2fa-verify" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
